import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const name = <FormattedMessage {...messages.activeShippingLocationsColumnHeader} />;

export default {
  getMessageDescriptor: () => messages.activeShippingLocationsColumnHeader,
  name,
  render: (data) =>
    data?.productWarehouses
      .filter((i) => i.isSelected)
      .map((i) => i.warehouseName)
      .join(', ') || '',
};
